import { request } from '../request'
import { Subscription } from '../types'

export class SubscriptionsService {

  getSubscriptions(): Promise<Subscription[]> {
    return request.get(`/api/subscriptions.json`)
  }

  getSubscriptionForCustomer(customerId: number): Promise<Subscription> {
    return request.get(`/api/customers/${customerId}/subscription.json`)
  }

  createSubscription(customerId: number, planCode: string, options: string[], quantity: number): Promise<any> {
    return request.post(`/api/customers/${customerId}/subscription.json`, { planCode, options, quantity })
  }
}
